import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { FlexRow } from 'ui-components/components/flex';
import { InfoIcon } from 'ui-components/components/info-icon';

import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { MessageDescriptorPropType } from '../../../../../prop-types/intl';
import { createColumnDefinitionBuilder } from '../../../../../components/items-table/create-column-definition-builder';

import style from '../style.module.less';

const DeleteItemColumnId = 'delete';

const deleteItemDataBuilder = (item) => ({
  id: item.id,
  readonly: item.readonly,
});

const ReadOnlyCell = ({ messageDescriptor = null }) => {
  const intl = useIntl();
  if (!messageDescriptor) {
    return null;
  }

  return (
    <FlexRow className={style['icon-container']}>
      <InfoIcon className={style['read-only-icon']} color={THEME_CONSTANTS.unstyled} tooltipText={intl.formatMessage(messageDescriptor)} />
    </FlexRow>
  );
};

ReadOnlyCell.propTypes = {
  messageDescriptor: MessageDescriptorPropType,
};

// TODO: we need to find a better trash icon here that's more in line with designs
const DeleteItem = ({ value: item, onRowDelete, disabled = false }) => {
  const onClick = useCallback(() => {
    onRowDelete(item.id);
  }, [item.id, onRowDelete]);

  if (item.readonly?.code) {
    return <ReadOnlyCell messageDescriptor={item.readonly.reasonMessageDescriptor} />;
  }

  return (
    <FlexRow className={style['icon-container']}>
      <Button className={style['delete-button']} disabled={disabled} onClick={onClick} theme='unstyled'>
        <FontAwesomeIcon icon={faTrash} />
      </Button>
    </FlexRow>
  );
};

DeleteItem.propTypes = {
  value: PropTypes.shape({
    id: PropTypes.string.isRequired,
    readonly: PropTypes.shape({
      code: PropTypes.string,
      reasonMessageDescriptor: MessageDescriptorPropType,
    }),
  }).isRequired,
  onRowDelete: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

const createDeleteItemColumnDefinition = createColumnDefinitionBuilder({
  header: '',
  accessor: DeleteItemColumnId,
  cell: DeleteItem,
  className: style['delete-cell'],
});

export { DeleteItemColumnId, deleteItemDataBuilder, createDeleteItemColumnDefinition };
